<template>
  <v-app class="bckgrnd">

    <v-card class="form-container" style="border:1px solid">
        
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
            <v-flex xs12 style="text-align:center">
                <v-avatar size="100" >
                <avatar :size="100" :username="loggedInUserName"></avatar>
             </v-avatar>
                <h4 style="padding-top:20px">{{form.fullName}}</h4>
            </v-flex>
          <v-flex xs12 md4 sm12 style="padding-right: 5px">
            <v-text-field readonly v-model="form.fullName" label="Full name" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md4 sm12 style="padding-right: 5px">
            <v-text-field readonly v-model="form.mobileNumber" type="Number" label="Mobile number" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md4 sm12 style="padding-right: 5px">
            <v-text-field readonly v-model="form.email" label="Email ID"></v-text-field>
          </v-flex>
          <v-flex xs12 style="text-align:right">
            <v-btn depressed color="black" dark @click="onEdit(form)">Edit</v-btn>
          </v-flex>

        </v-layout>
      </v-form>
    </v-card>

    
  </v-app>
</template>

<script>
import Avatar from "vue-avatar";
import config from "../../config.json";
export default {
    components: {
   Avatar,
  },
  data() {
    return {
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      dialog: false,


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      loggedInUserName: sessionStorage.loggedInUserName,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Teacher",
          disabled: false,
          to: "/teacher"
        },
        {
          text: "Create teacher",
          disabled: true,
          to: "/createTeacher"
        }
      ],

      form: {
      }
    };
  },

  mounted() {
    this.axios
      .get(config.API + `MyProfile`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
      });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    onEdit(form) {
      this.$router.push(`/editCustomer/${form.id}`);
    }
  }
};
</script>

<style>
.bckgrnd {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
img.center {
    display: block;
    margin: 0 auto;
}
.hvr:hover {
  cursor: pointer;
  color: #3486D7;
  text-decoration: underline;
}
</style>
